var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMinimizeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.625,
    width: 38.75,
    height: 38.75,
    rx: 19.375,
    stroke: "#0066CC",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 11.75H28.25C28.6478 11.75 29.0294 11.908 29.3107 12.1893C29.592 12.4706 29.75 12.8522 29.75 13.25V26.75C29.75 27.1478 29.592 27.5294 29.3107 27.8107C29.0294 28.092 28.6478 28.25 28.25 28.25H11.75C11.3522 28.25 10.9706 28.092 10.6893 27.8107C10.408 27.5294 10.25 27.1478 10.25 26.75V13.25C10.25 12.8522 10.408 12.4706 10.6893 12.1893C10.9706 11.908 11.3522 11.75 11.75 11.75ZM28.25 13.25H24.5V26.75H28.25V13.25ZM11.75 26.75H23V13.25H11.75V26.75Z",
    fill: "#0066CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 13H24V27H28.5V13Z",
    fill: "#0066CC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMinimizeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/minimizeIcon.9ab45467ebf23b1ba8f62db8faa44bc4.svg";